import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueRouter from "vue-router";
import Home from "./components/Home.vue"
import Termsandconditions from "./components/Termsandconditions.vue"

//import { component } from 'vue/types/umd';
// import firebase from 'firebase/app'
// import 'firebase/firestore'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
routes: [
  {
    path: '/',
    component: Home
  },
  {
    path: '/termsandconditions',
    component: Termsandconditions
  }
]

});

Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false

// firebase.initializeApp({
//  Configurações do seu app
// })

// export const db = firebase.firestore()

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
